import { Component, OnInit } from '@angular/core';
import { StepType, RegistrationStepService, EmailTypeStatus } from '@fgb/core';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
@Component({
  selector: 'fgbcl-registration-opt-out-emails',
  templateUrl: './registration-opt-out-emails.component.html',
  styleUrls: ['./registration-opt-out-emails.component.scss'],
})
export class RegistrationOptOutEmailsComponent implements OnInit {
  readonly stepType: StepType = StepType.OptOutEmails;
  optOutEmails$: Observable<EmailTypeStatus[]>;
  optOutEmails: EmailTypeStatus[];

  constructor(private registrationStepService: RegistrationStepService) {}

  ngOnInit() {
    this.optOutEmails$ = this.registrationStepService.fetchRegistrationStepForCurrentWizard(this.stepType).pipe(
      map((step) => (step ? step.Data : undefined)),
      tap((emails) => (this.optOutEmails = emails))
    );
  }

  submitStep() {
    const stepData = this.optOutEmails;
    if (stepData) {
      this.registrationStepService.submitRegistrationStepData(this.stepType, stepData).toPromise();
    }
  }
}
